import { render, staticRenderFns } from "./BatchFeatureNePanel.vue?vue&type=template&id=2feb54be&"
import script from "./BatchFeatureNePanel.vue?vue&type=script&lang=js&"
export * from "./BatchFeatureNePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports